module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', {
    class: [(_vm.situacaoClass + "--text"), 'upperCase']
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.situacao))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa3eadb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tarefas/TarefasSituacao.vue
// module id = 1026
// module chunks = 1